import { pdf, PDFViewer } from '@react-pdf/renderer';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import { META_COLLECT_API } from '../../../api';
import { useSigninContext } from '../../../context/AuthProviderPages/Signin';
import { processImage } from '../../../pages/AppPages/pqfl/visits/components/content-wrapper/utils';
import { IPrintCollectOccurrencesResponse } from '../../../types/PrintOccurrences';
import { LoadingData } from '../../LoadingData';
import { CollectOccurrencesDocument } from '../../Pdf/CollectOccurrences';
import { ModalInfoTemplete } from '../ModalInfoTemplete';

interface IPrintOccurrencesModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  idColeta?: string | number;
}

const ActionButton = styled.button`
  margin-left: auto;
  margin-right: 15px;
  background-color: transparent;
  color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 0.45rem;
  padding: 0.4rem 0.8rem;
  font-size: 0.75rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
  &:hover {
    background-color: rgba(0, 0, 0, 0.15);
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const PrintOccurrencesModal: React.FC<IPrintOccurrencesModalProps> = ({
  isOpen,
  onRequestClose,
  idColeta,
}) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<
    IPrintCollectOccurrencesResponse['data'] | null
  >(null);
  const { path, user } = useSigninContext();
  const [finalLogo, setFinalLogo] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (isOpen) {
      processImage(user?.DFLOGOEMPRESA).then(setFinalLogo);
    }
  }, [isOpen, user?.DFLOGOEMPRESA]);

  useEffect(() => {
    if (isOpen && idColeta && path) {
      setLoading(true);
      META_COLLECT_API.get<IPrintCollectOccurrencesResponse>(
        `/coleta/fechada/ocorrencias/imprimir?DFIDCOLETA=${idColeta}`,
        { headers: { path } },
      )
        .then((response: any) => {
          const loadedData = response.data.data;
          setData(loadedData);
          setLoading(false);
        })
        .catch((error: any) => {
          toast.error('Erro ao buscar dados para impressão das ocorrências.');
          setLoading(false);
          onRequestClose();
        });
    } else {
      setData(null);
    }
  }, [isOpen, idColeta, path]);

  const handleOpenNewTab = async () => {
    if (!data) return;
    const doc = (
      <CollectOccurrencesDocument
        data={data}
        logo={finalLogo}
        username={user?.DFLOGINUSUARIO}
      />
    );
    const blob = await pdf(doc).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  };

  return (
    <ModalInfoTemplete
      option="encerrada"
      titleModal={
        <TitleWrapper>
          <span>Relatório de Ocorrências</span>
        </TitleWrapper>
      }
      closeModal={onRequestClose}
      isOpen={isOpen}
      headerAction={
        !loading &&
        data && (
          <ActionButton onClick={handleOpenNewTab}>
            📄 Abrir em Nova Aba
          </ActionButton>
        )
      }
    >
      <div style={{ width: '100%', height: '95vh' }}>
        {loading && (
          <LoadingData title="Carregando fotos e informações do relatório..." />
        )}
        {!loading && data && (
          <PDFViewer style={{ width: '100%', height: '100%', border: 'none' }}>
            <CollectOccurrencesDocument
              data={data}
              logo={finalLogo}
              username={user?.DFLOGINUSUARIO}
            />
          </PDFViewer>
        )}
        {!loading && !data && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <p>Nenhum dado disponível.</p>
          </div>
        )}
      </div>
    </ModalInfoTemplete>
  );
};
